import { useFormik } from 'formik'
import * as Yup from 'yup'
import { PhoneNumberUtil } from 'google-libphonenumber'
import { useTranslation } from 'react-i18next'

const phoneUtil = PhoneNumberUtil.getInstance()
const isPhoneValid = phone => {
    try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone))
    } catch (error) {
        return false
    }
}

export const useShuttleServiceForm = (initialValues, onSubmit) => {
    const { t } = useTranslation()

    const validationSchema = Yup.object().shape({
        provider_name: Yup.string().required('Provider name is required'),
        service_description_en: Yup.string().required('English service description is required'),
        service_description_ar: Yup.string().required('Arabic service description is required'),
        contact_person: Yup.string().required('Contact person is required'),
        contact_mobile_number: Yup.string()
            .required(t('Mobile number is required'))
            .test('is-valid-phone', t('Invalid phone number'), value => isPhoneValid(value)),
        contact_email: Yup.string().email('Invalid email address').required('Email is required'),
        contact_address: Yup.string().required('Address is required'),
        country_code: Yup.string().required('Country is required'),
        price_base: Yup.number()
            .required(t('Base price is required'))
            .min(0.01, t('Base price must be greater than 0'))
            .typeError(t('Base price must be a valid number')),
        price_tax: Yup.number().required('Tax amount is required').min(0, 'Tax amount must be positive'),
        price_currency: Yup.string().required('Currency is required'),
    })

    return useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit,
    })
}

export const formatShuttleServiceData = values => {
    const basePrice = parseFloat(values.price_base)
    const taxAmount = parseFloat(values.price_tax)
    const grossAmount = basePrice + taxAmount

    return {
        provider: {
            provider_name: values.provider_name,
            service_description: {
                en: values.service_description_en,
                ar: values.service_description_ar,
            },
            contact: {
                person: values.contact_person,
                mobile_number: values.contact_mobile_number.trim(),
                email: values.contact_email,
                address: values.contact_address,
            },
            country_code: values.country_code,
            price: {
                base: basePrice,
                tax: taxAmount,
                gross: grossAmount,
                currency: values.price_currency,
            },
            isactive: values.isactive,
        },
    }
}
